import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import moment from 'moment';
import ReactHtmlParser from 'react-html-parser';
import NavBar from '../../_components/common/Navbar';
import Footer from '../../_components/common/Footer';
import { Link } from 'react-router-dom'
import { dashBoardAction } from '../../../src/_actions/dashBoard/dashBoardActions';
import { worksheetAction } from '../../_actions/WorkSheet/workSheet.action';
import TableNew from '../../_components/common/TableNew'
import SettingsHead from '../../_components/common/SettingsHead';
import CustomTableNew from '../../_components/common/CustomTableNew'
import '../../_components/common/CustomTableNew/index.css'
import './index.css'
import { createProfileAction } from '../../_actions';
import ModalNew from '../../_components/common/ModalNew';
import vviLogo from '../../images/vviLogo.png';
import loiLogo from '../../images/loiLogo.png';
import { LoaderComp } from '../../_components/common/LoaderComp/Loadercomp';
import table from './worksheet/tableData';
import Compass from '../../images/Compass.svg';



class DashBoardReport extends Component {
    constructor(props) {
        super(props);

    }
    state = {
        life_orientation_instrument: false,
        vision_value_instrument: false,
        my_invitations: false,
        workSheetState: false,
        toggle_previous_assessmet: false,
        goalSheetState: false,
        goalSheetStatePrev: false,
        show_more: false,
        loi: null,
        vvi: null,
        createProfileState: true,
        userAssessmentArr: [],
        my_inivation: [],
        older_my_inivation: [],
        invitation_table: [{
                name: '',
                key: 'user_assessment__instrument__instrument_name',
                type: 'logoText',
                content: '',
                linkActive: false,
                link: '',
                sort: false,
            },
            {
                name: 'RESPONSE FOR',
                key: 'user_assessment__participant__full_name',
                type: 'text',
                content: '',
                linkActive: false,
                link: '',
                sort: false,
            },
            {
                name: 'RELATION',
                key: 'assessor_group__assessor_name',
                type: 'text',
             
                content: '',
                linkActive: false,
                link: '',
                sort: false,
            },
            {
                name: 'EXPIRY DATE',
                key: 'user_assessment__expiry_date',
                type: 'date',
                content: '',
                linkActive: false,
                link: '',
                sort: false,
            },
            {
                name: 'STATUS',
                key: 'assessment_status__status_name',
                type: 'progressBubble',
                content: '',
                linkActive: false,
                link: '',
                sort: false,
            }
        ],
        uniKeys: [],
        previousAssessment: [],
        workSheetSharedData: [],
        sharedWithTableData: table.worksheetShared,
        serverTime: '',
        customReportData: []
    }

    componentDidMount() {
        const { dispatch, } = this.props;
        var token = localStorage.getItem('access_token')
      
        dispatch(dashBoardAction.dashBoardAction1(token))

        dispatch(worksheetAction.getSharedUsersHandler((sharedUsers) => {
            let workSheetSharedData = [...sharedUsers.data.response]
            workSheetSharedData.map(val => {
                let dateObj = new Date(val.worksheet__assessment__created);
                const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

                let month = dateObj.getUTCMonth();
                let year = dateObj.getUTCFullYear();

                let newdate = monthNames[month] + "-" + year;
                val.worksheet__assessment__created = newdate;
            })
            this.setState({
                workSheetSharedData
            })
        }))


    }

    componentDidUpdate(prev) {
     
        if (prev.dashBoardData !== this.props.dashBoardData) {
            if (this.props.dashBoardData !== '' && this.props.dashBoardData !== undefined) {
             
                this.props.dashBoardData.my_inivation.map(ob => {
                    if (!ob.is_submited) {
                        this.state.my_inivation.push(ob)
                    }
                    this.state.older_my_inivation.push(ob)

                })

                const user_assessments = [...this.props.dashBoardData.user_assessments];

                const customReportData_unsorter = user_assessments.filter(val => {
                    return (val.enable_report && val.is_submited) && val.instrument__is_multi_rater
                })

                const customReportData = customReportData_unsorter.sort((a, b) => {
                    return new Date(a.created) - new Date(b.created)
                })


                let instrumentIdArr = [];


            
                let sortedUserAssessment = user_assessments.sort(function(a, b) {
                    // Turn your strings into dates, and then subtract them
                    // to get a value that is either negative, positive, or zero.
                    return new Date(a.created) - new Date(b.created);
                });

                // function to remove duplicates from array
                function removeDuplicates(originalArray, prop) {
                    var newArray = [];
                    var lookupObject = {};

                    for (var i in originalArray) {
                        lookupObject[originalArray[i][prop]] = originalArray[i];
                    }

                   

                    for (i in lookupObject) {
                        newArray.push(lookupObject[i]);
                    }
                    return newArray;
                }

                //remove duplicate instrument id obj from array                
                let userAssessmentArr = removeDuplicates(sortedUserAssessment, "instrument__id");

                //add removed object to new array
                let previousAssessment = sortedUserAssessment.filter(function(obj) { return userAssessmentArr.indexOf(obj) == -1; });


                this.setState({
                    serverTime: this.props.dashBoardData.current_server_time,
                    userAssessmentArr,
                    previousAssessment,
                    customReportData
                }, () => {
                    if (this.state.previousAssessment.length <= 5) {
                        this.setState({
                            toggle_previous_assessmet: true
                        })
                    }
                    this.setState({ uniKeys: [...(new Set(this.state.userAssessmentArr.map(({ instrument__instrument_name }) => instrument__instrument_name)))] })
                })
            }
        }

    }

    rowClickable(data) {
    
        this.props.history.push({
                pathname: `/app/dashBoard/continueReport/${data.user_assessment__id}/assessments`,
                state: { detail: 'Invitation' }
            })
            // this.props.history.push(`/app/dashBoard/continueReport/${data.user_assessment__id}/assessments`)
    }
    dispatchData = (handler, data) => {
        const { dispatch } = this.props;

        
        dispatch(handler(data))
    }

    toggleEntireCreateProfileModal = (showModal) => {
        this.setState({
            createProfileState: showModal
        })
    }

    actionSelected = (data) => {
    
        const fd = data.sellerData;

        const formData = {
                'full_name': fd.Name,
                // 'gender': fd.gender,
                'short_name': fd.Short_name
            }
        

        localStorage.setItem('is_sign_up_completed', 'true')
        localStorage.setItem('user_name', fd.Short_name)
        this.props.dispatch(createProfileAction.createProfileHandler(formData))
        this.props.dispatch(createProfileAction.isSignUpCompleted, 'true')
    }

    filterDataSharedData(data) {
        this.setState({
            workSheetSharedData: data
        })
    }

    renderDashBoard() {
            const { dashBoardData, dash_board_data_loading, dash_board_data_error, isSignUpCompletedResponse, getSharedUsersLoading, workSheetSharedError } = this.props
            const short_name = localStorage.getItem('short_name');
            const full_name = localStorage.getItem('full_name');
            const baseLink = localStorage.getItem('baseLink');
           
            isSignUpCompletedResponse === '' ? this.props.dispatch(createProfileAction.isSignUpCompleted(localStorage.getItem('is_sign_up_completed'))) : isSignUpCompletedResponse
            const userType = localStorage.getItem('usertype');
            const formData = [{
                    key: 'Name',
                    type: 'text',
                    value: full_name === '' || full_name === 'null' ? '' : full_name,
                    valid: full_name === '' || full_name === 'null' ? false : true,
                    regex: "^[a-zA-Z]+[a-zA-Z ]+$",
                    elementConfig: {
                        name: 'Name',
                        label: 'Name',
                        placeholder: 'Your Name'
                    },
                    validation: {
                        required: true,
                        message: "is required"
                    },

                }, {
                    key: 'Short_name',
                    type: 'text',
                    value: short_name === '' || short_name === 'null' ? '' : short_name,
                    valid: short_name === '' || full_name === 'null' ? false : true,
                    regex: "^[a-zA-Z]*[a-zA-Z ]+$",
                    elementConfig: {
                        name: 'Short_name',
                        label: 'Short Name',
                        placeholder: 'Your Short name'
                    },
                    validation: {
                        required: true,
                        message: "is required"
                    },
                },
                //  {
                //     key: 'gender',
                //     type: 'select',
                //     value: '',
                //     valid: true,
                //     elementConfig: {
                //         name: 'gender',
                //         label: 'Gender',
                //         options: [{ 'gender': "Male", id: 1 },
                //         { 'gender': "Female", id: 2 },
                //         { 'gender': "Others", id: 3 }]
                //     },
                //     validation: {
                //         required: false,
                //         message: "",
                //         displayText: "",
                //     },
                // }
            ]

            const isAdmin = userType.includes('super_admin') || userType.includes('seller_admin') || userType.includes('organisation_admin')
            const { createProfileState } = this.state
            
            var button;
            return (

                <
                div className = "container custom-container my-5"
                style = {
                    { color: '#666' }
                } > {
                    isSignUpCompletedResponse === 'false' && (userType.includes('participant') && !isAdmin || userType.length === 0) &&
                    <
                    ModalNew
                    showModal = { createProfileState }
                    hideClose = { true }
                    selectKey = {
                        ['id']
                    }
                    selects = {
                        ['gender']
                    }
                    modalName = "createProfile"
                    heading = "CREATE PROFILE"
                    formData = { formData }
                    action = { this.actionSelected.bind(this) }
                    toggleEntireModal = { this.toggleEntireCreateProfileModal.bind(this) }
                    />
                }

                {
                    this.state.uniKeys.map((obj1, key) => {
                            let subArr = []
                            let mainArr = this.state.userAssessmentArr.map((val, key) => {
                                if (obj1 == val.instrument__instrument_name) {
                                    subArr.push(val)
                                }
                                if (this.state.userAssessmentArr.length === (key + 1)) {
                                    return subArr
                                }
                            })
                            return ( <
                                    div >
                                    <
                                    DataBlock {...this.props }
                                    svTime = { this.state.serverTime }
                                    dbData = { mainArr }
                                    key = { key }
                                    /> {
                                    /* {
                                                                        mainArr[0] !== undefined ?
                                                                            mainArr[0].map(val => {
                                                                                return val.enable_report && val.is_submited &&
                                                                                    <CustomReport data={val} {...this.props} />
                                                                            })
                                                                        :
                                                                            mainArr[1].map(val => {
                                                                                return val.enable_report && val.is_submited &&                                                                                        
                                                                                <CustomReport data={val} {...this.props} />
                                                                            })
                                                                    } */
                                } <
                                /div>
                        )
                    })
            }

            {
                /* <div style={{marginBottom: 30}}>
                                    <div className="bg-green rounded-top">
                                        <div style={{display: 'flex', alignItems: 'center'}}> 
                                            <h5 className="text-uppercase py-2 text-white mb-0 p-2"> VISION VALUE INSTRUMENT </h5>
                                            <i className="fas fa-info text-white" style={{ padding: '10px'}} onClick={() => this.setState({vision_value_instrument: !this.state.vision_value_instrument})}></i>
                                       </div>
                                    </div>
                                    {
                                        this.state.vision_value_instrument ? 
                                        <div className="p-3" style={{borderStyle:'solid',borderBottomWidth:1,borderTopWidth:0,borderRightWidth:0,borderLeftWidth:0}}>
                                            <p>ABOUT THE VVI</p>
                                            <p>{this.state.userAssessmentArr.map(val => {
                                            return val.instrument__instrument_name === 'VVI' &&
                                             val.instrument__description
                                        })}</p>
                                        </div> :
                                        null
                                    }
                                    {
                                        true ?
                                        this.state.userAssessmentArr.map(val => {
                                            return val.instrument__instrument_name === 'VVI' &&
                                                        <DataBlock dbData={val}/>
                                        })
                                        :
                                        <div>
                                            <p>No data to display</p>
                                        </div>
                                    }
                                </div> */
            } {
                (!dash_board_data_loading && !dash_board_data_error) && (!getSharedUsersLoading && !workSheetSharedError) ?
                <
                div > {
                        this.props.dashBoardData.my_inivation.length === 0 && this.props.dashBoardData.user_assessments.length === 0 && this.state.workSheetSharedData.length === 0 ?
                        <
                        div style = {
                            { textAlign: 'center' }
                        } >
                        <
                        img src = { Compass }
                        width = "200px" / >
                        <
                        h4 > You don 't have any activity to show</h4> < /
                        div > :
                            <
                            React.Fragment >
                            <
                            div style = {
                                { marginBottom: 30 }
                            } >
                            <
                            div className = "bg-green rounded-top animation-fade-in" >
                            <
                            div className = ""
                        style = {
                            { display: 'flex', alignItems: 'center' }
                        } >
                        <
                        h5 className = "text-uppercase py-2 text-white mb-0 p-2 panel-title panel-two" > MY INVITATIONS < /h5> <
                        i className = "fas fa-info-circle text-white"
                        style = {
                            { fontSize: '14px', paddingBottom: 3, cursor: 'pointer' }
                        }
                        onClick = {
                            () => this.setState({ my_invitations: !this.state.my_invitations })
                        } > < /i> < /
                        div > <
                        /div> {
                        this.state.my_invitations ?
                        <
                        div className = "p-3 animation-fade-in"
                        style = {
                            { borderStyle: 'solid', borderBottomWidth: 1, borderTopWidth: 0, borderRightWidth: 0, borderLeftWidth: 0 }
                        } >
                        <
                        p className = "panel-title" > ABOUT INVITATIONS < /p> <
                        p > These are the people who have invited you to assess them.Click on any invitation below to proceed. < /p> < /
                        div > : null
                    } { <
                        div > {
                                // this.state.my_inivation.length == 0 &&
                                // <p style={{ textAlign: 'center' }}>No new invitations</p>
                                // :
                                // <CustomTableNew
                                //     data={this.state.my_inivation !== '' ? this.state.my_inivation : []}
                                //     columns={this.state.invitation_table}
                                //     showSlNo="false"
                                //     rowClickable={{
                                //         func: (data) => this.rowClickable(data)
                                //     }}
                                // />
                                <
                                div > {
                                    this.state.show_more ?
                                    <
                                    div style = {
                                        { textAlign: 'center' }
                                    }
                                    className = "animation-fade-in" > {
                                        this.state.older_my_inivation.length ?
                                        <
                                        CustomTableNew
                                        data = { this.state.older_my_inivation }
                                        columns = { this.state.invitation_table }
                                        showSlNo = "false"
                                        checkbox = "false"
                                        rowClickable = {
                                            {
                                                func: (data) => this.rowClickable(data)
                                            }
                                        }
                                        // selectCheckBox = { this.selectAllBatchDetailsBox.bind(this) }
                                        // getData = { this.getSelectedData.bind(this) }
                                        // format = {[{
                                        //     format: 'icon',
                                        //     key: 'is_submited'
                                        // }]}
                                        // CheckKey = {'participant__email'}
                                        // modalOpener = {this.modalOpener.bind(this)}
                                        // sortBy={(key) => this.sortBy(key, !this.state.sortTypeallot, 'organisationallotTable')}
                                        // sortType={this.state.sortTypeallot}
                                        /> : <
                                        p > No Older Invitations < /p>
                                    } <
                                    button className = {
                                        "btn bg-gray btn-sm text-uppercase text-white animation-fade-in"
                                    }
                                    style = {
                                        { margin: '2px', fontSize: '10px' }
                                    }
                                    onClick = {
                                        () => this.setState({ show_more: !this.state.show_more })
                                    } >
                                    Show Active <
                                    /button> < /
                                    div > :
                                        <
                                        div style = {
                                            { textAlign: 'center' }
                                        }
                                    className = "animation-fade-in" > {
                                        this.state.my_inivation.length ?
                                        <
                                        CustomTableNew
                                        data = { this.state.my_inivation }
                                        columns = { this.state.invitation_table }
                                        showSlNo = "false"
                                        checkbox = "false"
                                        rowClickable = {
                                            {
                                                func: (data) => this.rowClickable(data)
                                            }
                                        }
                                        // selectCheckBox = { this.selectAllBatchDetailsBox.bind(this) }
                                        // getData = { this.getSelectedData.bind(this) }
                                        // format = {[{
                                        //     format: 'icon',
                                        //     key: 'is_submited'
                                        // }]}
                                        // CheckKey = {'participant__email'}
                                        // modalOpener = {this.modalOpener.bind(this)}
                                        // sortBy={(key) => this.sortBy(key, !this.state.sortTypeallot, 'organisationallotTable')}
                                        // sortType={this.state.sortTypeallot}
                                        /> : <
                                        p > You have no new invitations < /p>
                                    } <
                                    button className = {
                                        "btn bg-gray btn-sm text-uppercase text-white animation-fade-in"
                                    }
                                    style = {
                                        { margin: '2px', fontSize: '10px' }
                                    }
                                    onClick = {
                                        () => {

                                            this.setState({ show_more: !this.state.show_more })
                                        }
                                    } > Show older < /button> < /
                                    div >
                                } <
                                /div>
                            } <
                            /div>
                    } <
                    /div> <
                div style = {
                        { marginBottom: 30 }
                    } >
                    <
                    div className = "mb-5" > {
                        this.state.previousAssessment.length != 0 ?
                        <
                        div className = "bg-gray rounded-top animation-fade-in"
                        style = {
                            { display: 'flex', alignItems: 'center', cursor: 'pointer' }
                        }
                        onClick = {
                            () => this.setState({ toggle_previous_assessmet: !this.state.toggle_previous_assessmet })
                        } >
                        <
                        h5 className = "text-uppercase py-2 text-white mb-0 p-2 panel-title" > PREVIOUS ASSESSMENTS < /h5> <
                        i className = { this.state.toggle_previous_assessmet ? 'fas fa-chevron-up text-white' : 'fas fa-chevron-down text-white' }
                        style = {
                            { padding: '10px' }
                        } > < /i> < /
                        div > : null
                    }

                {
                    this.state.toggle_previous_assessmet === true ?
                        this.state.previousAssessment.map((val, key) => {
                             
                                return ( <
                                        div className = "animation-fade-in" >
                                        <
                                        PrevAssessment svTime = { this.state.serverTime }
                                        dbData = { val }
                                        key = { key }
                                        /> {
                                        /* {
                                                                                                                (val.enable_report && val.is_submited) && val.instrument__is_multi_rater ?
                                                                                                                    <CustomReport {...this.props} data={val} /> : null
                                                                                                            } */
                                    } <
                                    /div>
                            )
                        }) :
                null
            } <
            /div> {
            this.state.customReportData.length ?
                <
                div >
                <
                div className = "bg-green rounded-top animation-fade-in"
            style = {
                { display: 'flex', alignItems: 'center', cursor: 'pointer' }
            }
            onClick = {
                    () => this.setState({ goalSheetState: !this.state.goalSheetState })
                } >
                <
                h5 className = "text-uppercase py-2 text-white mb-0 p-2 panel-title" > GOAL - SETTING WORKSHEETS < /h5> <
            i className = { this.state.goalSheetState ? 'fas fa-chevron-up text-white' : 'fas fa-chevron-down text-white' }
            style = {
                { padding: '10px' }
            } > < /i> < /
            div >

                {
                    this.state.customReportData.length ?
                    this.state.customReportData.map((val, key) => {
                        if (key === 0) {
                            return ( <
                                div style = { this.state.goalSheetState ? { display: 'block' } : { display: 'none' } }
                                className = "customReportBorderDiv animation-fade-in" >
                                <
                                div className = "customReportClass" >
                                <
                                p style = {
                                    { margin: 0 }
                                } > { val.instrument__instrument_name } < /p> <
                                img width = "30"
                                src = { baseLink + '/media/' + val.instrument__instrument_image }
                                /> < /
                                div > <
                                CustomReport allData = { this.state.customReportData }
                                data = { val } {...this.props }
                                /> < /
                                div >
                            )
                        }
                    }) : null
                } <
                /div>:
            null
        } {
            (!getSharedUsersLoading && !workSheetSharedError) &&
            <
            div > {
                    this.state.workSheetSharedData.length ?
                    <
                    div className = "mt-5" >
                    <
                    div style = {
                        { height: 40 }
                    }
                    className = "bg-green rounded-top" > { <
                        div className = "d-flex justify-content-between align-items-center" >
                        <
                        p > < /p> <
                        p className = "h6 text-center text-uppercase py-2 text-white mb-0 quattrocentosans regular" > WORKSHEETS SHARED WITH ME < /p> {
                        (!getSharedUsersLoading && !workSheetSharedError) ?
                        <
                        p > < /p>: <
                        LoaderComp color = { 'white' }
                        />
                    } <
                    /div>
                } <
                /div>

         

            <
            SettingsHead
            buttonData = {
                []
            }
            columns = { this.state.sharedWithTableData }
            view = { this.filterDataSharedData.bind(this) }
            sellers = { this.props.workSheetSharedData }
            showModal = { false }
            filter = "true"
            widthClass = { 'd-none' }
            /> <
            CustomTableNew
            data = { this.state.workSheetSharedData }
            columns = { this.state.sharedWithTableData }
            showSlNo = "false"
            noPointerClass = { true }
            />

            <
            /div> :
            null
        } <
        /div>
} <
/div> < /
React.Fragment >
} <
/div>: <
div >
    <
    div className = "rounded-top animation-fade-in" >
    <
    div className = ""
style = {
        { display: 'flex', justifyContent: 'space-between' }
    } >
    <
    p className = "text-uppercase py-2 text-white mb-0 p-2 panel-title panel-one" > < /p> <
LoaderComp color = { 'black' }
/> <
p > < /p> < /
div > <
    /div> < /
div >
}



<
/div>
)
}

render() {
    if (!this.props.error) {
        return ( <
            div >
            <
            NavBar / > { this.renderDashBoard() } <
            Footer / >
            <
            /div>
        );
    } else {
        return (
            // add swal
            <
            h1 > Something went wrong < /h1>
        );
    }

}

}

class CustomReport extends Component {
    state = {
        workSheetState: false,
        orientationData: [],
        goalSheetStatePrev: false,
    }
    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(worksheetAction.orientationApi({
            instrument_id: this.props.data.instrument__id
        }, this.props.data.id))
    }

    componentDidUpdate(prevProps) {
        if (prevProps.worksheetOrientationReducer !== this.props.worksheetOrientationReducer) {
            let orientationData = [];
            this.props.worksheetOrientationReducer.map(val => {
                if (val.id === this.props.data.id) {
                    orientationData = [...val.orientation.data.response]
                }
            })
            this.setState({
                orientationData
            }, () => {
               
            })
        }
    }

    render() {
        const { orientationData } = this.state;
        const baseLink = localStorage.getItem('baseLink');

        return ( <
            div className = "pb-5 customReportCollapse" >

            <
            div className = "pi-worksheet-list animation-fade-in " >
            <
            p > Use these worksheets to create and manage a holistic plan
            for achieving your goals: < /p> <
            ul > {
                orientationData.map(val => {
                    return ( <
                        li >
                        <
                        b > { val.orientation__orientation_name }: < /b> {val.orientation__short_description} < /
                        li >
                    )
                })
            } <
            /ul> <
            Link className = {
                "btn btn-red text-uppercase"
            }
            onClick = {
                () => {
                    localStorage.setItem('currentInstrumentId', this.props.data.instrument__id)
                    localStorage.setItem('assessmentCreationDate', this.props.data.created)
                }
            }
            style = {
                { margin: '2px', fontSize: '14px' }
            }
            to = {
                {
                    pathname: `/app/dashboard/${this.props.data.id}/workSheet`,
                    state: { assessmentData: this.props.data }
                }
            } >
            CREATE / MANAGE WORKSHEETS <
            /Link> < /
            div >

            {
                this.props.allData.length > 1 ?
                <
                div style = {
                    { padding: 10 }
                } >
                <
                div className = "bg-gray rounded-top animation-fade-in"
                style = {
                    { width: '100%', display: 'flex', alignItems: 'center', cursor: 'pointer' }
                }
                onClick = {
                    () => this.setState({ goalSheetStatePrev: !this.state.goalSheetStatePrev })
                } >
                <
                h5 className = "text-uppercase py-2 text-white mb-0 p-2 panel-title" > GOAL - SETTING WORKSHEETS < /h5> <
                i className = { this.state.goalSheetStatePrev ? 'fas fa-chevron-up text-white' : 'fas fa-chevron-down text-white' }
                style = {
                    { padding: '10px' }
                } > < /i> < /
                div > {
                    this.state.goalSheetStatePrev ?
                    this.props.allData.map((val, key) => {
                        if (key !== 0) {
                            return ( <
                                div style = { this.state.goalSheetStatePrev ? { display: 'block' } : { display: 'none' } }
                                className = "customReportBorderDiv  customReportCollapse" >
                                <
                                div className = "customReportClass" >
                                <
                                p style = {
                                    { margin: 0 }
                                } > { val.instrument__instrument_name } < /p> <
                                img width = "30"
                                src = { baseLink + '/media/' + val.instrument__instrument_image }
                                /> < /
                                div > <
                                div className = "pi-worksheet-list animation-fade-in" >
                                <
                                p > Use these worksheets to create and manage a holistic plan
                                for achieving your goals: < /p> <
                                Link className = {
                                    "btn btn-red text-uppercase"
                                }
                                onClick = {
                                    () => {
                                        localStorage.setItem('currentInstrumentId', this.props.data.instrument__id)
                                        localStorage.setItem('assessmentCreationDate', this.props.data.created)
                                    }
                                }
                                style = {
                                    { margin: '2px', fontSize: '14px' }
                                }
                                to = {
                                    {
                                        pathname: `/app/dashboard/${this.props.data.id}/workSheet`,
                                        state: { assessmentData: this.props.data }
                                    }
                                } >
                                CREATE / MANAGE WORKSHEETS <
                                /Link> <
                                ul > {
                                    orientationData.map(val => {
                                        return ( <
                                            li >
                                            <
                                            b > { val.orientation__orientation_name }: < /b> {val.orientation__short_description} < /
                                            li >
                                        )
                                    })
                                } <
                                /ul>

                                <
                                /div> < /
                                div >
                            )
                        }
                    }) : null
                } <
                /div>:
                null
            }

            <
            /div>
        )
    }
}

const PrevAssessment = (props) => {
    const { dbData } = props;
    const baseLink = localStorage.getItem('baseLink')

    let expiredState = false

    let expiryDate = new Date(dbData.expiry_date);
    let currentDate = new Date(props.svTime);
    let timeDiff = expiryDate.getTime() - currentDate.getTime();
    let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

 

    if (diffDays < 0) {
        expiredState = true
    }

    const changedDateFormat = (date) => {
        const endDate = moment(date, 'YYYY-MM-DD').format('DD-MM-YYYY')
        let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        let dateArr = endDate.split('-')
        let dicreement = dateArr[1] - 1
        let changedDate = months[dicreement]
        dateArr[1] = changedDate
        let properDate = dateArr.join('-')
        return properDate;
    }

    const checkExpiredDate = (date) => {
        let currentDate = new Date(props.svTime).toLocaleDateString('en-US');

        let providedDate = new Date(date).toLocaleDateString('en-US');

        if (new Date(currentDate).getTime() <= new Date(providedDate).getTime()) {
            return true
        }
        return false
    }

    return ( <
        div className = "p-3 animation-fade-in"
        style = {
            { display: 'flex', flexDirection: 'row' }
        } >
        <
        div style = {
            { flex: 0.5, justifyContent: 'center', alignItems: 'center', paddingBottom: 3 }
        } > {
            dbData.instrument__instrument_name === 'VVI' ?
            <
            img src = { baseLink + '/media/' + dbData.instrument__instrument_image }
            width = { 30 }
            /> : <
            img src = { baseLink + '/media/' + dbData.instrument__instrument_image }
            width = { 30 }
            />
        } <
        /div> <
        div style = {
            { flex: 2 }
        } >
        <
        p > { dbData.participant__full_name }
        's {dbData.instrument__instrument_name}</p> < /
        div > <
        div style = {
            { flex: 3 }
        } > {
            checkExpiredDate(dbData.expiry_date) ?
            <
            p className = "mb-0" > Expires on { changedDateFormat(dbData.expiry_date) } < /p> : <
            p className = "mb-0" > Expired on { changedDateFormat(dbData.expiry_date) } < /p>                                        
        } <
        /div> <
        div style = {
            { flex: 2 }
        } >
        <
        div >
        <
        div style = {
            { display: 'flex' }
        } > {
            checkExpiredDate(dbData.expiry_date) &&
            dbData.enable_report && dbData.is_submited ?
            <
            div className = "progressTab" >
            <
            div className = { "progressTabGreen" } >

            <
            /div> <
            div className = { "progressTabGreen" } >

            <
            /div> <
            div className = { "progressTabGreen" } >

            <
            /div> <
            i className = "fas fa-check" > < /i> < /
            div > :
                <
                div >
                <
                i className = "fas fa-exclamation-triangle"
            style = {
                { padding: '10px' }
            } > < /i> < /
            div >
        } <
        /div> < /
        div > <
        /div> <
        div style = {
            { flex: 2 }
        } > {
            expiredState == true ?
            <
            p className = "mb-0" > Expired < /p>: <
            p className = "mb-0" > { dbData.enable_report === true && dbData.assessment_status__status_name === 'Report in review' ? 'Report ready' : dbData.assessment_status__status_name === 'Completed' && dbData.is_self_assessment_completed && !dbData.is_submited ? 'Self Completed' : dbData.assessment_status__status_name } < /p>
        } <
        /div> <
        div style = {
            { flex: 1.8 }
        } > {
            /* <Link to={{
                                            pathname: (dbData.assessment_status__status_name == 'Yet to start' ||  dbData.assessment_status__status_name == 'In progress') || (dbData.assessment_status__status_name == 'Completed' || dbData.assessment_status__status_name != 'Expired') ? `/app/dashBoard/continueReport/${dbData.id}` : dbData.report_available == true && dbData.enable_report == true  ? `/dashBoard/viewReport/${dbData.id}` : null,
                                            // `/app/dashBoard/continueReport/${dbData.id}`: `/app/dashBoard/viewReport/${dbData.id}`
                                            state: { dbData }
                                        }}>
                                        <button 
                                            className={
                                                "btn btn-red btn-sm text-uppercase"
                                            }
                                            style={{margin: '2px',fontSize:'10px'}}
                                        >
                                           {(dbData.assessment_status__status_name == 'Yet to start' ||  dbData.assessment_status__status_name == 'In progress') || (dbData.assessment_status__status_name == 'Completed' || dbData.assessment_status__status_name != 'Expired') ? 'continue' : 'View Report'} 
                                        </button>
                                    </Link> */
        } {
            // expiredState === true ||  
            (dbData.assessment_status__status_name == 'Report in review' && dbData.enable_report == false) ?
            <
            button
            className = {
                "btn bg-gray btn-sm text-uppercase"
            }
            style = {
                    { margin: '2px', fontSize: '10px', color: "#fff", width: '100%' }
                } > { expiredState === true ? 'EXPIRED' : dbData.assessment_status__status_name == 'Report in review' && dbData.enable_report == false ? 'Report in Review' : 'EXPIRED' } <
                /button>:
            checkExpiredDate(dbData.expiry_date) &&
                dbData.enable_report && dbData.is_submited &&
                <
                Link to = {
                    {
                        pathname: dbData.assessment_status__status_name === 'Report in review' && dbData.enable_report == true ? `/app/dashBoard/viewReport/${dbData.id}` : `/app/dashBoard/continueReport/${dbData.id}`,
                        // `/app/dashBoard/continueReport/${dbData.id}`: `/app/dashBoard/viewReport/${dbData.id}`
                        state: { dbData }
                    }
                }
            style = {
                { width: '100%' }
            }
            className = { dbData.enable_report && dbData.is_submited ? "" : "disableButton" } >
                <
                button
            className = {
                "btn btn-red btn-sm text-uppercase"
            }
            style = {
                    { margin: '2px', fontSize: '10px', width: '100%' }
                } > { /* {dbData.assessment_status__status_name == 'Yet to start' ? "START" : dbData.assessment_status__status_name == 'In progress' ? "CONTINUE" : dbData.assessment_status__status_name == 'Completed' && dbData.respondent_completed < dbData.batch__min_respondent ? "INVITE RESPONDENTS" : dbData.assessment_status__status_name == 'Completed' && dbData.respondent_completed >= dbData.batch__min_respondent ? "Ready to submit" : dbData.enable_report == true ? 'View Report' : dbData.enable_report == false ? 'Report in Review' : 'null'} */ } { dbData.enable_report && dbData.is_submited ? "View Report" : "Expired" } <
                /button> < /
            Link >

                //  <Link to={{
                //     pathname: dbData.report_available == true && dbData.enable_report == true ? `/app/dashBoard/viewReport/${dbData.id}` : `/app/dashBoard/continueReport/${dbData.id}`,
                //     // `/app/dashBoard/continueReport/${dbData.id}`: `/app/dashBoard/viewReport/${dbData.id}`
                //     state: { dbData }
                // }}>
                //     <button
                //         className={
                //             "btn btn-red btn-sm text-uppercase"
                //         }
                //         style={{ margin: '2px', fontSize: '10px' }}
                //     >
                //         {dbData.assessment_status__status_name == 'Yet to start' ? "START" : dbData.assessment_status__status_name == 'In progress' ? "CONTINUE" : dbData.assessment_status__status_name == 'Completed' && dbData.respondent_completed < dbData.batch__min_respondent ? "Self Completed" : dbData.assessment_status__status_name == 'Completed' && dbData.respondent_completed >= dbData.batch__min_respondent ? "Ready to submit" : dbData.assessment_status__status_name == 'View report' && dbData.enable_report == true ? 'View Report' : dbData.assessment_status__status_name == 'Report in review' && dbData.enable_report == false ? 'Report in Review' : null}
                //     </button>
                // </Link>

        } <
        /div> < /
        div >

    )
}

class DataBlock extends Component {
    constructor() {
        super()
        this.state = {
            mainArray: [],
            subArray: [],
            info_toggler: false,
            instrumentName: '',
            instrumentDescrpition: '',
            infoModal: true,
            expiredState: false
        }
    }

    componentDidMount() {

        const { dbData } = this.props
        this.setState({ mainArray: dbData }, () => {
                this.state.mainArray.map(val => {
                    val == undefined ? {} : this.setState({ subArray: val }, () => {
                        this.state.subArray.map((obj) => {
                            let expiryDate = new Date(obj.expiry_date);
                            let currentDate = new Date(this.props.svTime);
                            let timeDiff = expiryDate.getTime() - currentDate.getTime();
                            let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
                            let expired = false
                            if (diffDays < 0) {
                                expired = true
                            }
                            
                            this.setState({ expiredState: expired, instrumentName: obj.instrument__dashboard_header_text, instrumentDescrpition: obj.instrument__dashboard_header_description })
                        })
                    })
                })
            })
         

    }


    infoToggle = () => {
        this.setState({
            infoModal: false
        })
    }


    changedDateFormat = (date) => {
        const endDate = moment(date, 'YYYY-MM-DD').format('DD-MM-YYYY')
        let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        let dateArr = endDate.split('-')
        let dicreement = dateArr[1] - 1
        let changedDate = months[dicreement]
        dateArr[1] = changedDate
        let properDate = dateArr.join('-')
        return properDate;
    }

    checkExpiredDate = (date) => {

        let comparedBool = moment(date).diff(this.props.svTime, 'days');

        if (comparedBool >= 0) {
            return true
        }
        return false
    }

    checkMandateBool = (data) => {
        const countBool = data.respondent_completed >= data.batch__min_respondent;
        const mandateName = data.batch__organisation_mandate_group__assessor_group__assessor_name;

        if (countBool) {
            if (mandateName !== null) {
                let mandateBool = false;

                data.respondents.map(val => {
                    if (mandateName === val.assessor_group__assessor_name) {
                        mandateBool = true;
                    };
                });
                return mandateBool;
            } else {
                return countBool;
            }
        } else {
            return countBool;
        };
    }

    render() {

        const baseLink = localStorage.getItem('baseLink')


        if (this.state.subArray.length === 0) {
            return ( <
                div > < /div >
            )
        } else {

            return ( <
                React.Fragment >

                <
                div >
                <
                div className = "bg-green rounded-top animation-fade-in" >
                <
                div style = {
                    { display: 'flex', alignItems: 'center' }
                } >
                <
                h5 className = "text-uppercase py-2 text-white mb-0 p-2 panel-title panel-one" > { `${this.state.instrumentName}`.toUpperCase() } < /h5> <
                i className = "fas fa-info-circle text-white"
                style = {
                    { fontSize: '16px', paddingBottom: 3, cursor: 'pointer' }
                }
                onClick = {
                    () => this.setState({ info_toggler: !this.state.info_toggler })
                } > < /i> < /
                div > <
                /div> {
                this.state.info_toggler ?
                <
                div className = "p-3"
                style = {
                    { borderStyle: 'solid', borderBottomWidth: 0, borderTopWidth: 0, borderRightWidth: 0, borderLeftWidth: 0 }
                } > { /* <p className="panel-title ">{`${this.state.instrumentName}`.toUpperCase()}</p> */ } <
                div > { ReactHtmlParser(this.state.instrumentDescrpition) } < /div> < /
                div > :
                null
            } {
                this.state.subArray.map(dbData => {
                        return ( <
                                div >

                                <
                                div className = "p-3"
                                style = {
                                    { display: 'flex', flexDirection: 'row' }
                                } >
                                <
                                div style = {
                                    { flex: 0.5, justifyContent: 'center', alignItems: 'center', paddingBottom: 3 }
                                } > {
                                    dbData.instrument__instrument_name === 'VVI' ?
                                    <
                                    img src = { baseLink + '/media/' + dbData.instrument__instrument_image }
                                    width = { 30 }
                                    /> : <
                                    img src = { baseLink + '/media/' + dbData.instrument__instrument_image }
                                    width = { 30 }
                                    />
                                } <
                                /div> <
                                div style = {
                                    { flex: 2 }
                                } >
                                <
                                p > { dbData.participant__full_name }
                                's {dbData.instrument__instrument_name}</p> < /
                                div > <
                                div style = {
                                    { flex: 2.5 }
                                } > {
                                    this.checkExpiredDate(dbData.expiry_date) ?
                                    <
                                    p > Expires on { this.changedDateFormat(dbData.expiry_date) } < /p> : <
                                    p > Expired on { this.changedDateFormat(dbData.expiry_date) } < /p>                                                    
                                } <
                                /div> <
                                div style = {
                                    { flex: 2 }
                                } >
                                <
                                div >
                                <
                                div style = {
                                    { display: 'flex' }
                                } > {
                                    this.checkExpiredDate(dbData.expiry_date) ?
                                    <
                                    div className = "progressTab" >
                                    <
                                    div className = { dbData.is_submited && (dbData.assessment_status__status_name === 'Completed' || dbData.assessment_status__status_name === "Report in review") ? 'progressTabGreen' : !dbData.is_submited && dbData.assessment_status__status_name === 'Completed' ? "progressTabYellow" : dbData.assessment_status__status_name === 'In progress' ? 'progressTabYellow' : dbData.instrument__is_multi_rater === false && (dbData.enable_report && dbData.is_submited) ? 'progressTabGreen' : 'progressTabRed' } >

                                    <
                                    /div> <
                                    div className = { dbData.is_submited && (dbData.assessment_status__status_name === 'Completed' || dbData.assessment_status__status_name === "Report in review") ? 'progressTabGreen' : !dbData.is_submited && dbData.assessment_status__status_name === 'Completed' ? "progressTabYellow" : dbData.assessment_status__status_name === 'In progress' ? 'progressTabYellow' : dbData.instrument__is_multi_rater === false && (dbData.enable_report && dbData.is_submited) ? 'progressTabGreen' : 'progressTabWhite progressTabBorderRed' } >

                                    <
                                    /div> <
                                    div className = { dbData.is_submited && (dbData.assessment_status__status_name === 'Completed' || dbData.assessment_status__status_name === "Report in review") ? 'progressTabGreen' : !dbData.is_submited && dbData.assessment_status__status_name === 'Completed' ? "progressTabWhite progressTabBorderYellow" : dbData.assessment_status__status_name === 'In progress' ? 'progressTabWhite progressTabBorderYellow' : dbData.instrument__is_multi_rater === false && (dbData.enable_report && dbData.is_submited) ? 'progressTabGreen' : 'progressTabWhite progressTabBorderRed' } >

                                    <
                                    /div> {
                                    dbData.assessment_status__status_name === 'Report in review' && dbData.enable_report &&
                                    <
                                    i className = "fas fa-check" > < /i>
                                } <
                                /div> : <
                                div >
                                <
                                i className = "fas fa-exclamation-triangle"
                                style = {
                                    { padding: '10px' }
                                } > < /i> < /
                                div >
                            } <
                            /div> < /
                        div > <
                            /div> <
                        div style = {
                                { flex: 2 }
                            } > {
                                this.checkExpiredDate(dbData.expiry_date) ?
                                <
                                p > { dbData.enable_report === true && dbData.assessment_status__status_name === 'Report in review' ? 'Report ready' : dbData.assessment_status__status_name === 'Completed' && dbData.is_self_assessment_completed && !dbData.is_submited ? 'Self Completed' : dbData.assessment_status__status_name } < /p> : <
                                p > Expired < /p>
                            } <
                            /div> <
                        div style = {
                                { flex: 1.8 }
                            } > {
                                /* <Link to={{
                                                                    pathname: (dbData.assessment_status__status_name == 'Yet to start' ||  dbData.assessment_status__status_name == 'In progress') || (dbData.assessment_status__status_name == 'Completed' || dbData.assessment_status__status_name != 'Expired') ? `/app/dashBoard/continueReport/${dbData.id}` : dbData.report_available == true && dbData.enable_report == true  ? `/app/dashBoard/viewReport/${dbData.id}` : null,
                                                                    // `/app/dashBoard/continueReport/${dbData.id}`: `/app/dashBoard/viewReport/${dbData.id}`
                                                                    state: { dbData }
                                                                }}>
                                                                <button 
                                                                    className={
                                                                        "btn btn-red btn-sm text-uppercase"
                                                                    }
                                                                    style={{margin: '2px',fontSize:'10px'}}
                                                                >
                                                                {(dbData.assessment_status__status_name == 'Yet to start' ||  dbData.assessment_status__status_name == 'In progress') || (dbData.assessment_status__status_name == 'Completed' || dbData.assessment_status__status_name != 'Expired') ? 'continue' : 'View Report'} 
                                                                </button>
                                                            </Link> */
                            } {
                      
                            } {
                                dbData.assessment_status__status_name === 'Report in review' && dbData.enable_report == false ?
                                    <
                                    button
                                className = {
                                    "btn bg-gray btn-sm text-uppercase text-white"
                                }
                                style = {
                                        { margin: '2px', fontSize: '10px', cursor: 'not-allowed', width: '100%' }
                                    } >
                                    Report in Review <
                                    /button> : <
                                React.Fragment > {
                                        this.state.expiredState == true ?
                                        <
                                        React.Fragment > {
                                            dbData.is_submited ?
                                            <
                                            Link to = {
                                                {
                                                    pathname: dbData.assessment_status__status_name === 'Report in review' && dbData.enable_report == true ? `/app/dashBoard/viewReport/${dbData.id}` : `/app/dashBoard/continueReport/${dbData.id}`,
                                                    // `/app/dashBoard/continueReport/${dbData.id}`: `/app/dashBoard/viewReport/${dbData.id}`
                                                    state: { dbData }
                                                }
                                            }
                                            style = {
                                                { width: '100%' }
                                            }

                                            >
                                            <
                                            button
                                            className = {
                                                "btn btn-red btn-sm text-uppercase"
                                            }
                                            style = {
                                                { margin: '2px', fontSize: '10px', width: '100%' }
                                            } > { dbData.enable_report == true ? 'View Report' : dbData.assessment_status__status_name == 'Report in review' && dbData.enable_report == false ? 'Report in Review' : null } <
                                            /button> < /
                                            Link > : <
                                                button
                                            className = {
                                                "btn bg-gray btn-sm text-uppercase text-white"
                                            }
                                            style = {
                                                { margin: '2px', fontSize: '10px', cursor: 'not-allowed', width: '100%' }
                                            } >
                                            Expired <
                                            /button> 
                                        } <
                                        /React.Fragment> : <
                                        Link to = {
                                            {
                                                pathname: dbData.assessment_status__status_name === 'Report in review' && dbData.enable_report == true ? `/app/dashBoard/viewReport/${dbData.id}` : `/app/dashBoard/continueReport/${dbData.id}`,
                                                // `/app/dashBoard/continueReport/${dbData.id}`: `/app/dashBoard/viewReport/${dbData.id}`
                                                state: { dbData }
                                            }
                                        }
                                        style = {
                                            { width: '100%' }
                                        }
                                        className = { this.state.expiredState ? "disableButton" : "" } >
                                        <
                                        button
                                        className = {
                                            "btn btn-red btn-sm text-uppercase"
                                        }
                                        style = {
                                            { margin: '2px', fontSize: '10px', width: '100%' }
                                        } > { this.state.expiredState ? 'EXPIRED' : dbData.assessment_status__status_name == 'Yet to start' ? "START" : dbData.assessment_status__status_name == 'In progress' ? "CONTINUE" : dbData.assessment_status__status_name == 'Completed' && !this.checkMandateBool(dbData) ? "Invite RESPONDENTS" : dbData.assessment_status__status_name == 'Completed' && this.checkMandateBool(dbData) ? "Ready to submit" : dbData.assessment_status__status_name == 'View report' && dbData.enable_report == true ? 'View Report' : dbData.assessment_status__status_name == 'Report in review' && dbData.enable_report == false ? 'Report in Review' : dbData.assessment_status__status_name == 'Report in review' && dbData.enable_report == true ? 'View Report' : null } <
                                        /button> < /
                                        Link >
                                    } <
                                    /React.Fragment>
                            } <
                            /div> < /
                        div >

                            <
                            /div>
                    )
                })
        } <
        /div>

        <
        /React.Fragment>

    )
}
return ( <
    div >

    <
    /div>
)

}

}


function mapStateToProps(state) {
   
    const { isSignUpCompletedLoading } = state.isSignUpCompletedReducer;
    const isSignUpCompletedResponse = (!isSignUpCompletedLoading) ? state.isSignUpCompletedReducer.data : '';
    //dash Board
    const { dash_board_data_loading, dash_board_data_error } = state.dashBoardRed;
    const dashBoardData = (!dash_board_data_loading && !dash_board_data_error) ? state.dashBoardRed.dash_board_data.data : ''

    const { orientationError, orientationLoading } = state.worksheetOrientationReducer
    const worksheetOrientationReducer = (!orientationError, !orientationLoading) ? state.worksheetOrientationReducer.orientationData : []


    const workSheetSharedError = state.getSharedUsersReducer.error;
    const { getSharedUsersLoading } = state.getSharedUsersReducer;
    const workSheetSharedData = (!workSheetSharedError && !getSharedUsersLoading) ? state.getSharedUsersReducer.data.data.response : []


    return {
        isSignUpCompletedLoading,
        isSignUpCompletedResponse,
        dashBoardData,
        dash_board_data_loading,
        dash_board_data_error,
        worksheetOrientationReducer,

        workSheetSharedError,
        workSheetSharedData,
        workSheetSharedData
    };
}

export default connect(mapStateToProps)(DashBoardReport);


// WEBPACK FOOTER //
// ./src/_pages/DashBoard/index.js